import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boothCodeFilter'
})
export class BoothCodeFilterPipe implements PipeTransform {

  transform(value: any[], booth_code: string): any[] {
    if (booth_code !== '') {
      return value.filter(
        item => item.business_code.toLowerCase().indexOf(booth_code.toLowerCase()) > -1);
    } else {
      return value;
    }
  }

}
